import { useModelesLLM } from 'lauria/contexts/ModelesLLMContext'

export const PromptModeleTag: React.FC<{
  modele: string
}> = ({ modele }) => {
  const { modeles } = useModelesLLM()
  const modeleLabel = modeles?.find((m) => m.nom === modele)?.label ?? ''
  return <div className="tag-modele">{modeleLabel}</div>
}
